import Image from "next/image";

import styled from "styled-components";

import { Typo } from "@enkor/design/components";
import { blue, grayScale, pink } from "@enkor/design/colors";
import { ellipsis } from "@enkor/design/mixins";

export const AVATAR_SIZE = 20;

export const Container = styled.section`
  background-color: ${grayScale[200]};
`;

export const DetailWrapper = styled.div`
  padding: 24px 16px 0;
`;

export const AvatarImageWrapper = styled.div<{ $withBorder?: boolean }>`
  position: relative;
  overflow: hidden;

  width: ${AVATAR_SIZE}px;
  height: ${AVATAR_SIZE}px;
  border: ${({ $withBorder }) =>
    $withBorder ? `1px solid ${grayScale.main}` : "none"};
  border-radius: 50%;
`;

export const HostInfo = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;

  margin-top: 8px;
`;

export const HostName = styled(Typo.Text)`
  color: ${grayScale[700]};
`;

export const EventTitle = styled(Typo.Heading)`
  margin-top: 8px;
`;

export const EventInfoSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;

  margin-top: 16px;
`;

export const EventDescription = styled(Typo.Text)<{ $shouldShowAll: boolean }>`
  word-break: break-word;

  ${({ $shouldShowAll }) => ($shouldShowAll ? null : ellipsis(5))}

  & > a {
    color: ${blue.main};
    text-decoration: underline;
  }
`;

export const DescriptionToggle = styled.button`
  width: fit-content;

  color: ${pink.main};
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
`;

export const EventInfoList = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;

  margin: 32px 0 24px;
  padding: 0 16px;
`;

export const EventInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  padding: 24px;
  border-radius: 8px;

  background-color: ${grayScale[300]};
`;

export const InfoIconWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  height: fit-content;
  border-radius: 8px;
`;

export const InfoIconText = styled(Typo.Heading)`
  color: ${grayScale[800]};
`;

export const InfoContentWrapper = styled.div<{ $hasLink?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;

  cursor: ${({ $hasLink }) => ($hasLink ? "pointer" : "default")};
`;

export const InfoName = styled(Typo.Text)<{ $hasLink?: boolean }>`
  display: flex;
  gap: 2px;
  align-items: center;

  cursor: ${({ $hasLink = false }) => ($hasLink ? "pointer" : "default")};
`;

export const InfoContent = styled(Typo.Text)`
  display: inline;

  & > a {
    color: ${blue.main};
    text-decoration: underline;
  }
`;

export const AvatarSection = styled.section`
  margin-top: 16px;
  padding: 10px 16px;
  border-top: 1px solid ${grayScale.main};
  border-bottom: 1px solid ${grayScale.main};
`;

export const LocationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  width: 100%;
`;

export const LocationDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const LocationInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CategoryWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;
